import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useMortgage } from "@/hooks";
import { ContactContext } from "@/contexts/contact";
import { useContext } from "react";
import { calculatePriceDifference, isValidPriceInput, } from "@/components/utilsComponents/suggestPrice/priceCalculationUtils";
import { useI18n } from "@/shared/hooks";
export const useSuggestPriceCalculator = () => {
    const { t } = useI18n();
    const [percentageDifference, setPercentageDifference] = useState(null);
    const { control, setValue, watch } = useFormContext();
    const { defaultMessage } = useContext(ContactContext);
    const suggestedPriceValue = watch("suggestPrice");
    const { price } = useMortgage() || {};
    const originalPrice = price || 0;
    const IS_EXCEEDING_THRESHOLD = percentageDifference !== null &&
        !isNaN(percentageDifference) &&
        Math.abs(percentageDifference) > 15;
    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
    };
    const generatePriceMessage = useCallback((originalPrice, suggestedPrice) => {
        return t("contact.form.suggest_price.auto_message", {
            replace: {
                originalPrice: `${formatNumber(originalPrice)}\u00A0€`,
                suggestedPrice: `${formatNumber(suggestedPrice)}\u00A0€`,
            },
        });
    }, [t]);
    useEffect(() => {
        if (!isValidPriceInput(suggestedPriceValue)) {
            setPercentageDifference(null);
            setValue("message", defaultMessage);
            return;
        }
        const messageGenerator = (originalPrice, suggestedPrice) => {
            return generatePriceMessage(originalPrice, suggestedPrice);
        };
        const suggestedPriceNum = Number(suggestedPriceValue);
        const priceDiff = calculatePriceDifference(suggestedPriceNum, originalPrice);
        setPercentageDifference(priceDiff);
        const generatedMessage = messageGenerator(originalPrice, suggestedPriceNum);
        setValue("message", generatedMessage);
    }, [
        suggestedPriceValue,
        originalPrice,
        setValue,
        defaultMessage,
        generatePriceMessage,
    ]);
    return {
        percentageDifference,
        IS_EXCEEDING_THRESHOLD,
        control,
        originalPrice,
    };
};
